import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  .container {
    margin: 20px 0;

    &--query {
      width: 100%;
      background-color: white;
      margin: 0 0 20px 0;
      padding: 20px 0;
      -webkit-box-shadow: 0px 5px 8px -1px rgba(0, 0, 0, 0.15);
      box-shadow: 0px 5px 8px -1px rgba(0, 0, 0, 0.15);

      &--scrolled {
        position: fixed;
        z-index: 9;
        top: 59px;
      }
    }
  }

  .result-title {
    width: 100%;
    margin-bottom: 15px;

    @media (min-width: 1024px) {
      display: flex;
      align-items: flex-end;
    }

    @media (max-width: 1024px) {
      display: flex;
      gap: 8px;
      width: 100%;
      margin-left: 0;
      flex-direction: column-reverse;
    }

    > .result-title__refine,
    > .result-title__count {
      display: flex;
      align-items: center;

      h2 {
        margin-top: 0;
        margin-bottom: 0;
        font-weight: 500;
      }

      p {
        margin: 0;
      }

      @media (min-width: 1024px) {
        margin-right: 18px;
        min-width: 360px;
      }
    }

    > .result-title__count {
      align-items: flex-end;
      justify-content: space-between;
      gap: 10px;
      width: 100%;
      margin: 0;

      .result-title__count__buttons {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }
  }

  .result-header {
    width: 100%;

    @media (min-width: 1024px) {
      display: flex;
    }

    @media (max-width: 1024px) {
      width: 100%;
      margin-left: 0;
    }

    > .header {
      background: ${colors.darkerGray};
      color: white;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      min-height: 65px;
      padding-bottom: auto;

      @media (min-width: 1024px) {
        margin-right: 18px;
        min-width: 360px;
      }

      > div:first-of-type {
        display: flex;
        align-items: center;
        gap: 15px;
        padding-left: 17px;
      }

      .text {
        text-transform: uppercase;
      }

      > .icon-sidebar {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 100%;
        border-left: 2px solid ${colors.grayFive};

        & div {
          transform: rotate(90deg);
          -webkit-transition: -webkit-transform 0.3s ease-in-out;
          -ms-transition: -ms-transform 0.3s ease-in-out;
          transition: transform 0.3s ease-in-out;

          path {
            stroke: white;
          }
        }
      }
    }

    > .result-pagination {
      width: 100%;
      margin-right: 0px;
    }
  }

  .result-container {
    display: flex;
    position: relative;
    margin-bottom: 50px;

    @media (max-width: 1024px) {
      margin-left: 0;
    }

    & .facet-zone {
      background: ${colors.lightGreyTwo};
      border-bottom: 4px solid ${colors.darkerGray};
      min-width: 360px;
      max-width: 360px;
      margin-right: 18px;

      .close-filters {
        padding-left: 17px;
        padding-right: 20px;
        width: 100%;
        height: 65px;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
        line-height: 19px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: ${colors.darkerGray};
        color: white;

        path {
          fill: white;
        }
      }

      @media (max-width: 1024px) {
        position: fixed;
        top: 64px;
        left: 0;
        min-width: 100%;
        max-width: 100%;
        height: 100%;
        overflow: scroll;
        margin-right: 0px;
      }
    }

    > .result-zone {
      width: 100%;

      > .result-pagination {
        margin-right: 0px;
        margin-left: 0px;
      }

      > .results {
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;
        margin: 10px;
        margin-top: 0px;
        margin-left: 0px;
        margin-right: 0px;

        @media (max-width: 1024px) {
          margin-right: 0px;
          margin-left: 0px;
        }

        > div:last-child {
          > div {
            margin-right: 0px;
          }
        }

        > div:first-child {
          > div {
            margin-left: 0px;
          }
        }
      }
    }
  }

  .main-container__search__link {
    width: fit-content;
    text-decoration: underline;
    text-align: left;
    color: #636363;
    background: none;
    border: none;
    padding: 0;
    white-space: nowrap;
    cursor: pointer;
    transition: all 300ms;

    &:hover {
      color: black;
    }
  }

  .loading {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%);
    z-index: 10000;
    background-color: rgba(0, 0, 0, 0.7);

    img {
      width: 50px;
      animation: spin 1s linear infinite;

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }

  .advanced {
    &__header {
      &__button {
        border: 1px solid #cf4825ff;
        color: #cf4825ff;
        background-color: white;
        padding: 8px 13px;
        border-radius: 5px;
        cursor: pointer;
        transition: all 300ms;

        &--results {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
          background: none;
          border-radius: 100px;
          padding: 10px;
          width: 28px;
          height: 28px;
          cursor: pointer;

          &:hover {
            filter: brightness(90%);
          }
        }

        &__img {
          height: 16px;
          width: 16px;
        }
      }
    }
  }

  .button--help {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 100px;

    &__tooltip {
      position: absolute;
      top: -45px;
      color: #252525;
      background: white;
      padding: 10px 12px;
      border-radius: 5px;
      white-space: nowrap;
      visibility: hidden;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid #bfbfbf;
      font-weight: 400;
    }

    &:hover .button--help__tooltip {
      visibility: initial;
    }
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/pages/Result/style.js